import Checkmark from 'assets/icons/ios/ios-checkmark.svg'

Checkmark.displayName = 'Checkmark'
export default Checkmark
